/* eslint-disable import/no-default-export */
import React, { lazy, Suspense } from 'react';

import { connect } from 'react-redux';

const ClosedBoardsOverlayPromise = import(/* webpackChunkName: "gamma-closed-boards-overlay" */ './closed-boards-overlay');
const ClosedBoardsOverlay = lazy(() => ClosedBoardsOverlayPromise);

const CreateBoardOverlayPromise = import(/* webpackChunkName: "gamma-create-board-overlay" */ './create-board-overlay');
const CreateBoardOverlay = lazy(() => CreateBoardOverlayPromise);

// eslint-disable-next-line no-restricted-imports
import { OverlayType, State } from 'modules';

interface OverlaysProps {
  overlay: string;
}

const Overlays = ({ overlay }: OverlaysProps) => {
  let component;

  switch (overlay) {
    case OverlayType.CreateBoard:
      component = (
        <Suspense fallback={null}>
          <CreateBoardOverlay />
        </Suspense>
      );
      break;
    case OverlayType.ClosedBoards:
      component = (
        <Suspense fallback={null}>
          <ClosedBoardsOverlay />
        </Suspense>
      );
      break;
    default:
      component = null;
  }

  return component;
};

const mapStateToProps = (state: State) => ({
  overlay: state.ui.overlay,
});

export default connect(mapStateToProps)(Overlays);



// WEBPACK FOOTER //
// ./app/gamma/src/components/overlays/index.tsx